export default __webpack_public_path__ + "static/media/createTeamDark.edebf285.svg";